import React from "react";
import { motion } from "framer-motion";
import CTA from "./CTA";
import "./Header.css";
import ME from "../../assets/code2.jpg";
import HeaderSocials from "./HeaderSocials";
import { bounceY, fadeUp, headerContainer } from "../../animations";

const Header = () => {
  return (
    <header id="header">
      <div className="container header__container">
        {/* Hero texts wrapped in a motion.div to stagger */}
        <motion.div variants={headerContainer} initial="hidden" animate="visible">
          <motion.p variants={fadeUp}>Hello, I’m</motion.p>

          <motion.h1 variants={fadeUp}>Mahdi Chihi</motion.h1>

          <motion.h2 className="hero-title" variants={fadeUp}>
            Frontend Developer
          </motion.h2>

          <motion.p className="hero-subtitle" variants={fadeUp}>
            building performant, scalable, and visually refined user experiences
          </motion.p>

          <CTA />
        </motion.div>

        {/* Social links */}
        <HeaderSocials />

        {/* Profile image with pop-in and rotation */}
        <motion.div
          className="me"
          initial={{ opacity: 0, scale: 0.8, rotate: -5 }}
          animate={{ opacity: 1, scale: 1, rotate: 0 }}
          transition={{ duration: 1, delay: 0.6, ease: "easeOut" }}
        >
          <img src={ME} alt="Mahdi Chihi" />
        </motion.div>

        {/* Scroll down hint */}
        <motion.div className="scroll__down" variants={bounceY} animate="animate">
          <a href="#about">Scroll Down</a>
        </motion.div>
      </div>
    </header>
  );
};

export default Header;
